import React from "react";
import { cn } from "../../utils/cn";
import { Check } from "lucide-react";

export const Checkbox = ({
  checked = false,
  onChange,
  disabled = false,
  className,
  id,
  name,
  ...props
}) => {
  const handleClick = (e) => {
    if (disabled) return;
    if (onChange) {
      onChange({
        originalEvent: e,
        value: !checked,
        checked: !checked,
        target: { name, id, checked: !checked, value: !checked },
      });
    }
  };

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      id={id}
      name={name}
      disabled={disabled}
      onClick={handleClick}
      className={cn(
        "w-5 h-5 rounded-md border flex items-center justify-center transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-urb-primary focus-visible:ring-offset-1 focus-visible:ring-offset-urb-dark cursor-pointer",
        checked
          ? "bg-urb-primary border-urb-primary text-black"
          : "bg-slate-900 border-slate-700 hover:border-slate-500",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      {checked && <Check className="w-3.5 h-3.5 stroke-[3]" />}
    </button>
  );
};

export default Checkbox;
